export default __webpack_public_path__ + "static/media/0050.9f6e47d2.png";